import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import clsx from 'clsx';

type RateCardDiffProps = {
  change: number;
};

export function RateCardDiff({ change }: RateCardDiffProps) {
  return (
    <div
      className={clsx(
        'flex items-center border px-[2px] text-xs',
        change < 0 ? 'border-red-500 text-red-500' : 'border-green-500 text-green-500'
      )}>
      <FontAwesomeIcon icon={change < 0 ? faCaretDown : faCaretUp} className="mr-[2px]" />
      <div>{change.toFixed(1)}%</div>
    </div>
  );
}
